@if (status) {
  <div class="alert" role="alert"
     [ngClass]="{ 'alert-success':  operational,
                 'alert-danger': outage,
                 'alert-warning': degraded}">
    <div class="d-flex flex-column flex-md-row justify-content-md-between align-items-center">
      <div class="h4 p-0 m-0">{{ 'cloud_status_' + status | i18next }}</div>
      <div><a href="https://status.pascom.net" target="pascom_cloud_status">{{ 'cloud_status_link_text' | i18next }}</a></div>
    </div>
  </div>
}
